export const events = {
  createSoftwareSetup: 'Create software setup',
  deleteSoftwareSetup: 'Delete software setup',
  goToSoftwareSetupsList: 'Go to software setup list',
  goToSoftwareSetupDetail: 'Go to software setup detail',
  editSoftwareSetupSubmit: 'Edit software setup',
  openSoftwareSetupWizard: 'Open software wizard',
  goToSoftwareSetupWizardStep: 'Go to software wizard step',
  createCustomSoftware: 'Create custom software',
  goToEmployeeList: 'Go to employee list',
  goToEmployeeDetail: 'Go to employee detail',
  addSoftwareToEmployee: 'Add software to employee',
  removeSoftwareFromEmployee: 'Remove software from employee',
  selectCardBudgetFlexibility: 'Select a card budget flexibility',
  createSoftwareCard: 'Create a software setup card',
  goToSoftwareSetupEmployeeList: 'Go to the employee list for a software setup',
  goToTerminatedEmployeeList: 'Go to the terminated employee list',
  offboardTerminatedEmployees: 'Remove all the software from a terminated employee',
  clickOnCardOnboardingButton: 'Click on the card onboarding button',
  clickOnInvoiceBannerButton: 'Go to inbox',
  clickOnInvoiceBannerLink: 'Go to help center link',
}
